import {BrandAdvisorIcon, BrandCalendarIcon, BrandClockIcon, BrandFinancialExpertIcon, BrandMobileTextIcon} from "@pg-design/icons-module";

import {PictogramType} from "../types/PictogramType";

export const getLabeledIconsFromVariant = (variant: PictogramType) => {
    switch (variant) {
        case PictogramType.LABELED_ICON:
            return [
                {
                    label: "Szybka ocena zdolności kredytowej: sprawdzasz swoje możliwości finansowe",
                    icon: BrandClockIcon
                },
                {
                    label: "Kluczowa informacja dla doradców: doradca lepiej zrozumie Twoją sytuację",
                    icon: BrandAdvisorIcon
                },
                {
                    label: "Wyznacznik cen: wiesz, w jakim segmencie szukać swojego M",
                    icon: BrandMobileTextIcon
                },
                {
                    label: "Początek drogi po kredyt hipoteczny: rozpocznij, analizując swoją zdolność finansową",
                    icon: BrandFinancialExpertIcon
                }
            ];
        case PictogramType.BOX:
            return [
                {
                    label: "Szybka estymacja wysokości raty",
                    icon: BrandClockIcon
                },
                {
                    label: "Ważna wskazówka dla kredytobiorcy",
                    icon: BrandAdvisorIcon
                },
                {
                    label: "Wyznacznik cen szukanych mieszkań",
                    icon: BrandMobileTextIcon
                },
                {
                    label: "Miara zdolności spłaty",
                    icon: BrandCalendarIcon
                }
            ];
        default:
            return [];
    }
};
import {BrandAdvisorIcon, BrandCalendarIcon, BrandClockIcon, BrandFinancialExpertIcon, BrandMobileTextIcon} from "@pg-design/icons-module";

import {PictogramType} from "../types/PictogramType";

export const getLabeledIconsFromVariant = (variant: PictogramType) => {
    switch (variant) {
        case PictogramType.LABELED_ICON:
            return [
                {
                    label: "Szybka ocena zdolności kredytowej: sprawdzasz swoje możliwości finansowe",
                    icon: BrandClockIcon
                },
                {
                    label: "Kluczowa informacja dla doradców: doradca lepiej zrozumie Twoją sytuację",
                    icon: BrandAdvisorIcon
                },
                {
                    label: "Wyznacznik cen: wiesz, w jakim segmencie szukać swojego M",
                    icon: BrandMobileTextIcon
                },
                {
                    label: "Początek drogi po kredyt hipoteczny: rozpocznij, analizując swoją zdolność finansową",
                    icon: BrandFinancialExpertIcon
                }
            ];
        case PictogramType.BOX:
            return [
                {
                    label: "Szybka estymacja wysokości raty",
                    icon: BrandClockIcon
                },
                {
                    label: "Ważna wskazówka dla kredytobiorcy",
                    icon: BrandAdvisorIcon
                },
                {
                    label: "Wyznacznik cen szukanych mieszkań",
                    icon: BrandMobileTextIcon
                },
                {
                    label: "Miara zdolności spłaty",
                    icon: BrandCalendarIcon
                }
            ];
        default:
            return [];
    }
};
